/**
 * Athena-API client (used for execution-status lookups TestOps Hub renders
 * inline). The package's own backend calls (testops-hub/*) go through the
 * package's bundled api.ts, which honours VITE_ATHENA_API_URL too.
 */
import { createApiClient, onSessionExpired as sharedOnSessionExpired } from '@ytest/api-client'
import { tokenStorage } from '@ytest/auth-client'

const ATHENA_API_URL = import.meta.env.VITE_ATHENA_API_URL || 'https://api.athena.ytest.ai'
const IDENTITY_API_URL = import.meta.env.VITE_IDENTITY_API_URL || 'https://api.ytest.ai'

export const onSessionExpired = sharedOnSessionExpired

export const api = createApiClient({
  baseUrl: ATHENA_API_URL,
  getToken: () => tokenStorage.getAccessToken(),
  onUnauthorized: () => {
    tokenStorage.clearAll()
  },
  tokenRefresh: {
    identityApiUrl: IDENTITY_API_URL,
    getRefreshToken: () => tokenStorage.getRefreshToken(),
    onTokensRefreshed: (accessToken, refreshToken) => {
      tokenStorage.setTokens(accessToken, refreshToken)
      localStorage.setItem('token', accessToken)
    },
  },
})
